/* eslint-disable */

export const CommercePaymentOptionKind = {
  SavedCard: 'saved_card',
  NewCard: 'new_card',
  ApplePay: 'apple_pay',
  GooglePay: 'google_pay',
  Ach: 'ach',
  Redirect: 'redirect',
  None: 'none'
} as const;
export type CommercePaymentOptionKind = typeof CommercePaymentOptionKind[keyof typeof CommercePaymentOptionKind];
